<template>
  <AdminLayout>
    <Head title="Company Locations" />

    <template #sectionTitle> Settings </template>

    <template #pageTitle> Locations </template>

    <div class="panel">
      <form
        method="POST"
        @submit.prevent=""
      >
        <div class="grid grid-cols-12 gap-6">
          <div class="input-group col-span-12 sm:col-span-6">
            <label for="name"> Name </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.name"
              name="name"
              id="name"
            />
          </div>
          <div class="input-group col-span-12 sm:col-span-6">
            <label for="types"> Types </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.types"
              name="types"
              id="types"
            />
          </div>

          <div class="input-group col-span-12 sm:col-span-6">
            <label for="address_1"> Address 1 </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.address.street_1"
              name="address[address_1]"
              id="address_1"
            />
          </div>

          <div class="input-group col-span-12 sm:col-span-6">
            <label for="address_2"> Address 2 </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.address.street_2"
              name="address[address_2]"
              id="address_2"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-6 lg:col-span-4">
            <label for="city"> City </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.address.city"
              name="address[city]"
              id="city"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-3 lg:col-span-4">
            <label for="state"> State </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.address.state"
              name="address[state]"
              id="state"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-3 lg:col-span-4">
            <label for="zip"> Zip </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.address.zip"
              name="address[zip]"
              id="zip"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-6 lg:col-span-4">
            <label for="phone"> Phone </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.phone"
              name="phone"
              id="phone"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-3 lg:col-span-4">
            <label for="email"> Email </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.email"
              name="email"
              id="email"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-3 lg:col-span-4">
            <label for="website_url"> Website </label>
            <input
              type="text"
              disabled
              class="input-text"
              v-model="form.website_url"
              name="website_url"
              id="website_url"
            />
          </div>
        </div>
      </form>
    </div>
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link } from '@inertiajs/vue3'

export default {
  components: {
    AdminLayout,
    Head,
    Link
  },

  props: {
    location: Object
  },

  data() {
    return {
      form: {
        name: '',
        types: [],
        phone: null,
        email: null,
        website_url: null,
        address: {
          address_1: null,
          address_2: null,
          city: null,
          state: null,
          zip: null
        }
      }
    }
  },

  created() {
    this.form = {
      ...this.form,
      ...this.location.data
    }
  }
}
</script>
